/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {ProgressBar , Modal, Breadcrumb , Navbar , Card , Row , Col , Nav , NavDropdown, Button} from 'react-bootstrap'
import {ClassesService} from '../services';
import {ClassesStore, ProductStore , AccountStore} from '../store';
import Constants from '../constants.js';
import Overview from '../components/students/overview.js';
import Reports from '../components/students/reports.js';
import Assignments from '../components/students/assignments.js';
import Messages from '../components/students/messages.js';
import RecentActivity from '../components/reports/recent_activity_student.js';
import TextPopup from '../components/popup/text_popup.js';
import GeneratePDF from '../classes/pdf_generate.js'
import SelectPopup from '../components/popup/select_popup.js';
import Translation from '../store/internationalization-store.js';
import Comfirmation from '../components/popup/comfirmation_popup.js';
import ProductServices from '../services/product-service.js';
import AccountService from '../services/account-service.js'
import UserService from '../services/user-service.js'
import SelectMultiplePopup from '../components/popup/select_multiple_popup.js';
import Popup from '../components/popup/comfirmation_popup.js'
import FieldGroup from '../components/FieldGroup.js';

export default class Authentication extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.displayLimit = 5;

        this.state = {
            "tab":this.props.match.params.tab,
            "studentUid":this.props.match.params.id,
            languages:ProductStore.getLearningLanguages(),
            classes:[],
            "studentName":"",
            studentsData:[],
            loading:false,
        };
    }

    hasSelectedStudentChanged(newStudentUID){
        return this.state.studentUid != newStudentUID;
    }

    componentWillMount() {
        ProductStore.on(Constants.GET_LANGUAGES , ()=>{
            this.setState({
                "languages":ProductStore.getLearningLanguages(),
            });
        });

        AccountStore.on(Constants.GET_ACCOUNT_STUDENTS , ()=>{

            var students = AccountStore.students;
            var student = [];
            for (var i = 0; i < students.length; i++) {
                if (students[i].uid == this.props.match.params.id) {
                    student = students[i]
                    break;
                }
            }
            this.setState({
                studentsData:AccountStore.students || [],
                currentStudent:student,
                studentName:student.name,
                loading:true,
            })
        });

        ClassesStore.on(Constants.GET_MY_CLASSES , () => {

            this.setState({
                classes:ClassesStore.list
            });
        });
    }

    componentDidMount() {
        ProductServices.getAllLanguages();
        AccountService.getMembers();
        AccountService.getStudents();
        ClassesService.getMine();
    }

    removeStudent(){
        ClassesService.deleteStudent(this.props.match.params.id);
        window.location.hash = "#/student/management";
    }
        

    updateName(name){
        this.setState({
            studentName:name
        });
        ClassesService.updateStudentName(name , this.props.match.params.id)
    }

    componentWillReceiveProps(props){
        this.props = props;

        this.setState({
            "tab":this.props.match.params.tab,
            "studentUid":this.props.match.params.id
        });

    }

    handleSelect(eventKey) {
        window.location.hash = "students/"+eventKey+'/'+this.state.studentUid
    }


    getBody(){


        switch(this.state.tab)
        {
            case "news":return <RecentActivity studentUid={this.props.match.params.id}/>;
            case "overview": return <Overview languages={this.state.classLanguages} studentUid={this.props.match.params.id}/>;
            case "reports" : return <Reports screenID={this.props.match.params.screenID} language={this.props.match.params.language} 
                    studentUid={this.props.match.params.id} selectedReport={this.props.match.params.reportID}/>
            case "assignments": return <Assignments studentUid={this.props.match.params.id}/>
            case "messages": return <Messages studentUid={this.props.match.params.id}/>
            default : return <h1>{Translation.get(12735, "No tab selected")}</h1>
        }

    }

    getBreadCrumb(){

        switch(this.state.tab)
        {
            case "news":return Translation.get(12736 , 'News')
            case "overview":return Translation.get(2216 , 'Overview');
            case "teachers" :return Translation.get(4 , 'Teacher');
            case "lessons" : return Translation.get(12737 , 'Lessons');
            case "reports" : return Translation.get(12738 , 'Reports');
            case "highscores" : return Translation.get(12625 , 'High scores');
            case "assignments" : return Translation.get(12052 , 'Assignments');
            case "messages" : return Translation.get(12052 , 'Messages');
            case "grading" : return Translation.get(12739 , 'Grading');
            default : return 'error';
        }

    }

 
    shouldHide(){

        if(this.props.match.params.reportID)
        {
            return true;
        }

        return false;
    }

    updateStudentDefaultLanguage(language){
        ClassesService.updateStudentLanguage(language.value , this.props.match.params.id)
    }

    getClassLists() {
        
    }

    getPasswordGenerate() {
        return (
            <Modal
                onHide={()=>{this.setState({modifyPassword:false})}}
                show={this.state.modifyPassword}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {Translation.get(12653 , 'Generate new password')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="strong">
                        <Col md={12}>
                            <div >
                                {Translation.get(2444 , 'Are you sure you wish to generate a new password?')}
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={function(){this.setState({modifyPassword:false})}.bind(this)}>{Translation.get(12290, "No")}</Button>
                    <Button onClick={function(){
                        
                        UserService.updatePassword(this.props.match.params.id).then(function(response){
                            this.setState({
                                modifyPassword:false,
                                showPassword:true,
                                username:response.username,
                                password:response.password
                            })
                        }.bind(this))
                    }.bind(this)}>{Translation.get(12289, "Yes")}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    handelDownloadSingle(){
        this.PDFgen = new GeneratePDF();
        var studentData = [{"name":this.state.studentName, "username":this.state.username, "password":this.state.password}]
        this.PDFgen.generateNoClassPDF(studentData);
    }

    getPasswordShow() {
        return (
            <Modal
                onHide={()=>{this.setState({showPassword:false})}}
                show={this.state.showPassword}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {Translation.get(2423 , 'Student password')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <center><h5>{Translation.get(2424 , 'Student\'s Login Details')}</h5></center>
                    <br/>
                    <center><h4>{String(Translation.get(22 , 'Username:') +' '+this.state.username)}</h4></center>
                    <center><h4>{String(Translation.get(23 , 'Password:') +' '+this.state.password)}</h4></center>
                    <br/>
                    <center><h5>{Translation.get(12770 , 'Please keep your details safe and secure')}</h5></center>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=>{ this.handelDownloadSingle()}}  >{Translation.get(2445,'Download Login')}</Button>
                    <Button onClick={function(){this.setState({showPassword:false})}.bind(this)}>{Translation.get(495, "Ok")}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    updateClasses(classes) {
        ClassesService.updateStudentClasses(classes , this.props.match.params.id).then(function() {
            AccountService.getStudents();
        }.bind(this))
        this.setState({classModification:false});
    }

    render(){

        if(!this.state.loading) return <ProgressBar animated now={45} />

        var popup = <Popup oneButton={true} buttonTitle={Translation.get(12787, "Send")} title={this.state.studentName} 
        onSave={()=>{
            AccountService.createMessageStudent(this.state.messageTitle, this.state.messageMessage, this.state.studentUid)
            this.setState({addMessage:false});
        }} 
        onHide={()=>{
            this.setState({addMessage:false});
        }} 
        show={this.state.addMessage} 
        body={<div>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageTitle} 
                                onSelect={(event)=>{
                                    this.setState({lastSelected:event.target, lastSelectType:"title", lastPosition:undefined});
                                }} 
                                onChange={(event)=>{ this.setState({messageTitle:event.target.value}) }} 
                                className="strong" as="input" label={Translation.get(2202, 'Title')}  type="input" autofocus="true"/>
                    </Col>
                </Row>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageMessage} 
                                    onSelect={(event)=>{
                                        this.setState({lastSelected:event.target, lastSelectType:"message", lastPosition:undefined});
                                    }} 
                                    onChange={(event)=>{ this.setState({messageMessage:event.target.value}) }} 
                                    className="strong" as="input" label={Translation.get(12778, 'Subject')}  type="input" as="textarea" rows="3" />
                    </Col>
                </Row>
                {AccountService.getEmojiData(this)}
            </div>} />
        
        var defaultLanguage = [];
        if (this.state.currentStudent == undefined) {
            return "";
        }
        let languages = this.state.languages.map(function(object , index){
            if (object.ietf == this.state.currentStudent.defaultLanguage) {
                defaultLanguage = {label: Translation.get(object.name , 'Unkown'),value: object.ietf};
            }
            return {label: Translation.get(object.name , 'Unkown'),value: object.ietf};
        }.bind(this));

        let classesData = [];
        
        for (var i = 0; i < this.state.classes.length; i++) {
            classesData.push({label: this.state.classes[i].name,value: this.state.classes[i].uid});
        }
                                          
        let close = ()=>{ this.setState({modifyName:false})};
        let _delete = ()=>{ this.setState({comfirmation:false})};
        //<NavDropdown.Item onClick={ ()=>{ this.setState({modifyLanguages:true})}}>{Translation.get(-1 , 'Modify Default Language')}</NavDropdown.Item>
        //<NavDropdown.Item onClick={ ()=>{ this.setState({printableCertificates:true})}}>{Translation.get(-1 , 'Printable certificate')}</NavDropdown.Item>
        return <div >
            <Comfirmation onSave={this.removeStudent.bind(this)} body={Translation.get(2446, 'Are you sure you want to delete this student?')} onHide={_delete} show={this.state.comfirmation} />
            <SelectPopup value={defaultLanguage} onSave={this.updateStudentDefaultLanguage.bind(this)} data={languages} title={Translation.get(847 , 'Choose Language')} fieldTitle={Translation.get(12188 , 'Languages')}  onHide={ ()=>{ this.setState({modifyLanguages:false})}} show={this.state.modifyLanguages}/>
            <TextPopup onSave={this.updateName.bind(this)} value={this.state.studentName} title={ Translation.get(348 , "Edit Student Name")} fieldTitle={Translation.get(827 , "Student Name")} onHide={close} show={this.state.modifyName}/>
            {popup}
            {this.getPasswordGenerate()}
            {this.getPasswordShow()}
            <SelectMultiplePopup value={this.state.currentStudent.classesData} onSave={this.updateClasses.bind(this)} data={classesData} 
                    title={Translation.get(830 , 'Classes')} fieldTitle="Select Students" onHide={ ()=>{ this.setState({classModification:false})}}
                    show={this.state.classModification} />
            <Row>
                <Col sm={12} md={12}>
                    <Breadcrumb>
                        <Breadcrumb.Item href="#/student/management">{Translation.get(783 , 'Student Management')}</Breadcrumb.Item>
                        <Breadcrumb.Item active>{this.state.studentName}</Breadcrumb.Item>
                        <Breadcrumb.Item active>{this.getBreadCrumb()}</Breadcrumb.Item>
                    </Breadcrumb>
                    <Card >
                        <Card.Body>
                            <Row>
                                <Col md={12}>
                                    <Card.Title>{Translation.get(827 , 'Student Name')}: {this.state.studentName}</Card.Title>
                                    <Card.Subtitle className="mb-2 text-muted">{this.state.currentStudent.classes}</Card.Subtitle>
                                </Col>
                            </Row>
                            <hr/>
                            <Navbar style={{padding:0}}>
                                <Nav defaultActiveKey={this.state.tab} onSelect={k => this.handleSelect(k)}>
                                    <Nav.Item>
                                        <Nav.Link style={{paddingLeft:"0"}} eventKey="overview">{Translation.get(2216 , 'Overview')}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link style={{paddingLeft:"0"}} eventKey="news">{Translation.get(814 , 'Recent Activity')}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="reports">{Translation.get(12738 , 'Reports')}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="assignments">{Translation.get(12052 , 'Assignments')}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="messages">{Translation.get(2447 , 'Messages')}</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Navbar.Collapse className="justify-content-end">
                                    <NavDropdown drop={"down"} title={Translation.get(906, ' Settings')} id="basic-nav-dropdown">
                                        <NavDropdown.Item onClick={()=>{ this.setState({modifyName:true})}}>{Translation.get(12748 , 'Modify Name')}</NavDropdown.Item>
                                        <NavDropdown.Item onClick={ ()=>{ this.setState({modifyPassword:true})}}>{Translation.get(12653 , 'Generate New Password')}</NavDropdown.Item>
                                        <NavDropdown.Item onClick={ ()=>{ this.setState({classModification:true})}}>{Translation.get(830 , 'Classes')}</NavDropdown.Item>
                                        <NavDropdown.Item onClick={ ()=>{ this.setState({addMessage:true, messageMessage:"", messageTitle:""})}}>{Translation.get(2448 , 'Message Student')}</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item onClick={ ()=>{ this.setState({comfirmation:true})}}>{Translation.get(444 , 'Delete')}</NavDropdown.Item>
                                    </NavDropdown>
                                </Navbar.Collapse>
                            </Navbar>
                        </Card.Body>
                    </Card>
                    <br/>
                    <Card >
                        <Card.Body>
                            {this.getBody()}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    }


}